// src/routes/Login.js
import { Alert, Button, Box, Typography } from "@mui/material";
import { useSearchParams } from "react-router-dom";
import React from "react";
import { useTheme } from "@mui/material/styles";
import "../fonts/Milky-Matcha.otf";

const Login = () => {
  const theme = useTheme();
  const [searchParams] = useSearchParams();

  const discordLogin = () => {
    const clientId = process.env.REACT_APP_DISCORD_CLIENT_ID;
    const redirectUri = `${window.location.origin}/callback`; // dynamic per environment
    const scope = "identify guilds guilds.members.read";
    const discordUrl = `https://discord.com/oauth2/authorize?client_id=${clientId}&redirect_uri=${encodeURIComponent(redirectUri)}&response_type=code&scope=${encodeURIComponent(scope)}&prompt=consent`;
    window.location.href = discordUrl;
  };


  return (
    <>
      <Box
        sx={{
          minHeight: "80vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          px: 2,
        }}
      >
        <Typography
          variant="h1"
          sx={{
            fontFamily: "'Milky-Matcha', sans-serif",
            color: theme.palette.accent.main,
            textAlign: "center",
            mb: 4,
          }}
        >
          admin only
        </Typography>
        {searchParams.get("reason") === "session-expired" && (
          <Alert severity="info" sx={{ mb: 3 }}>
            Your admin session has expired. Please log in with Discord again.
          </Alert>
        )}
        <Button onClick={discordLogin}
          variant="contained"
          color="primary"
        >
          Login with Discord</Button>
      </Box>
    </>
  );
};

export default Login;
